<template>
  <CFooter :fixed="false">
    <div>
      <span class="mr-1">Descarregue a aplicação (IOS/Android)</span>
      <a href="https://apps.apple.com/us/app/Casa%20de%20Mateus/id1501527657" target="_blank"><i class="fab fa-apple"></i></a>
      <a href="https://play.google.com/store/apps/details?id=com.outsmartis.casamateus" target="_blank"><i class="fab fa-google-play"></i></a>
    </div>
    <div class="ml-lg-auto">
      <a class="mr-4" href="#/politica" target="_blank">Política de privacidade</a>
      <a href="mailto:webmaster@outsmartis.com" target="_blank" >webmaster@outsmartis.com</a>

    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
<style scoped>
a
{
  padding: 5px;
  color: #000 !important;

}
footer > div:nth-child(1) > a:nth-child(2) > .svg-inline--fa
{
  font-size: 25px;
}
footer > div:nth-child(1) > a:nth-child(3) > .svg-inline--fa
{
  font-size: 20px;
}
</style>
